import type { InputOptionType } from "src/types";

export const VALID_PAGE_SIZES = [5, 10, 25, 50] as const;

export const buildPageSizeOptions = (sizes: readonly number[]): InputOptionType[] =>
    sizes.map((size) => ({ label: size.toString(), value: size.toString() }));

export const readPersistedPageSize = (storageKey: string, defaultSize: number): number => {
    try {
        const stored = localStorage.getItem(storageKey);
        const parsed = stored === null ? NaN : Number(stored);
        return (VALID_PAGE_SIZES as readonly number[]).includes(parsed) ? parsed : defaultSize;
    } catch {
        return defaultSize;
    }
};

export const persistPageSize = (storageKey: string, size: number): void => {
    try {
        localStorage.setItem(storageKey, String(size));
    } catch {
        // ignore - e.g. private browsing / storage disabled, persistence is best-effort only
    }
};
